import { Controller } from "@hotwired/stimulus";

// Submits the filter form whenever a selection changes. Turbo Drive intercepts
// the GET request and follows the controller's canonical URL redirect.
export default class extends Controller {
  submit() {
    this.element.requestSubmit();
  }
}
